import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../App/State/Slices/SelectedCareersClientSlice";
import { Button, Card, CardContent, Grid, useTheme } from "@mui/material";
import YearMonthDayPicker from "../../../App/Components/Datepickers/YearMonthDayPicker";
import { getTypeReport, getUserList } from "../ReportsService";
import LineGraph from "../../../App/Components/Graphs/LineGraph";
import { basicConvertDate } from "../../../App/Helpers/DateConverters";
import SortableTable from "../../../App/Components/Table/SortableTable";
import ReportsTableCell from "./ReportsTableCell";
import PieChart from "../../../App/Components/Graphs/PieChart";
import BarGraph from "../../../App/Components/Graphs/BarGraph";
import { useReportDateState } from "../State/ReportDateState";

function TypeReport({ allTypes, type, label, optIn }) {
  const useStyles = makeStyles((theme) => ({
    root: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "50%",
    },
    graph: {
      width: "95%",
      height: "75vh",
      [theme.breakpoints.down("md")]: {
        height: "300px",
      },
    },

    sensitiveButton: {
      marginTop: "20px",
      height: "50%",
      width: "90%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
  }));

  const classes = useStyles();
  const theme = useTheme();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const dateState = useReportDateState();

  const [report, setReport] = useState({ dates: [], dateVal: [], users: [] });
  const [loading, setLoading] = useState(false);

  const graphData = {
    labels: report.dataTypes,
    datasets: [
      {
        data: report.dataVal,
        fill: true,
        lineTension: 0.4,
        backgroundColor: theme.palette.primary.graph,
        borderColor: theme.palette.primary.main,
      },
    ],
  };
  const columns = [
    { label: "Name", propName: "fullName" },
    { label: "Email Address", propName: "email" },
    { label: "Created On", propName: "dateCreated" },
    { label: "Updated On", propName: "dateUpdated" },
  ];

  const setData = (response) => {
    response.dataVal = response.data.map((a) => a.item2);
    response.dataTypes = response.data.map((a) => a.item1);
    response.users.forEach((row) => {
      if (row.firstName == null || row.lastName == null) {
        row.fullName = "Name Not Provided";
      } else {
        row.fullName = row.firstName + " " + row.lastName;
      }
      row.dateCreated = basicConvertDate(row.dateCreated);
      row.dateUpdated = basicConvertDate(row.dateUpdated);
    });
    setReport(response);
  };

  useEffect(() => {
    if (allTypes.length > 0) {
      setLoading(true);
      getTypeReport(
        selectCareersClient.id,
        dateState.getters.startDate.toDateString(),
        dateState.getters.endDate.toDateString(),
        type,
        optIn
      ).then((response) => {
        setData(response);
        setLoading(false);
      });
    }
  }, [
    selectCareersClient,
    dateState.getters.startDate,
    dateState.getters.endDate,
    optIn,
  ]);

  const searchData = () => {
    setLoading(true);
    getTypeReport(
      selectCareersClient.id,
      dateState.getters.startDate.toDateString(),
      dateState.getters.endDate.toDateString(),
      type,
      optIn
    ).then((response) => {
      setData(response);
      setLoading(false);
    });
  };

  return (
    <>
      {allTypes.length === 0 ? (
        <span>{"No " + label + " Data"}</span>
      ) : (
        <div className={classes.root}>
          <Grid className={classes.cardContainer}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={4}>
                    <YearMonthDayPicker
                      value={dateState.getters.startDate}
                      setValue={dateState.setters.setStartDate}
                      label="Start Date"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <YearMonthDayPicker
                      value={dateState.getters.endDate}
                      setValue={dateState.setters.setEndDate}
                      label="End Date"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} container justifyContent="flex-end">
                    <Button
                      style={{ marginTop: "20px", height: "50%", width: "90%" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() => searchData()}
                    >
                      Apply
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <BarGraph
            data={graphData}
            title={
              optIn
                ? label + " Marketing Signups"
                : label + " Job Alerts Signups"
            }
            loading={loading}
          />
          {report.users?.length > 0 && optIn ? (
            <Grid container spacing={1}>
              <Grid item xs={12} sm={1} container>
                <Button
                  className={classes.sensitiveButton}
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    getUserList(selectCareersClient.id, report.users)
                  }
                >
                  Export
                </Button>
              </Grid>
            </Grid>
          ) : null}
          {optIn ? (
            <SortableTable
              columns={columns}
              tableData={report.users}
              rowComponent={ReportsTableCell}
              loading={loading}
              hideSearch
            />
          ) : null}
        </div>
      )}
    </>
  );
}

export default TypeReport;
